/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Datastore API
 * API reference for Datastore API.
 *
 * Authentication: Auth0
 *
 * OpenAPI spec version: 3.0.0
 */
import type {
  GetUserNotificationSettingsResponse,
  UpdateUserNotificationSettingsRequestBody,
  UpdateUserNotificationSettingsResponse
} from '../model';

import getUserNotificationSettingsMutator from '../../../mutators/datastore-instance';
import putUserNotificationSettingMutator from '../../../mutators/datastore-instance';



  /**
 * ユーザー通知設定を取得する
 * @summary ユーザー通知設定取得
 */
export const getUserNotificationSettings = (

 ) => {
      return getUserNotificationSettingsMutator<GetUserNotificationSettingsResponse>(
      {url: `/user-notification-settings`, method: 'GET'
    },
      );
    }
  /**
 * ユーザー通知設定を更新する
 * @summary ユーザー通知設定更新
 */
export const putUserNotificationSetting = (
    updateUserNotificationSettingsRequestBody?: UpdateUserNotificationSettingsRequestBody,
 ) => {
      return putUserNotificationSettingMutator<UpdateUserNotificationSettingsResponse>(
      {url: `/user-notification-settings`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateUserNotificationSettingsRequestBody
    },
      );
    }
  export type GetUserNotificationSettingsResult = NonNullable<Awaited<ReturnType<typeof getUserNotificationSettings>>>
export type PutUserNotificationSettingResult = NonNullable<Awaited<ReturnType<typeof putUserNotificationSetting>>>
